import React, { ChangeEvent, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  CardMedia,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

import "react-phone-input-2/lib/bootstrap.css";
import MainContainer from "../../layout/MainContainer";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const EditUser = () => {
  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [Status, setStatus] = React.useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Edit User</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>User Management</button>{" "}
          - Edit
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group">
              <label htmlFor="icon-button-file">Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="Uploaded profile photo" />
                    </figure>
                    <IconButton
                      aria-label="Remove uploaded image"
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                      size="small"
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{ accept: "image/png,image/jpeg" }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage("This field only accepts images.");
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/placeholder.png" alt="placeholder" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            <div className="control_group w_33">
              <label htmlFor="full-name">Full Name</label>
              <TextField id="full-name" placeholder="Name" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="email">Email</label>
              <TextField id="email" type="email" placeholder="Email" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="gender">Gender</label>
              <Select id="gender" fullWidth value={Status} onChange={handleStatusChange}>
                <MenuItem disabled value="default">
                  Select Gender
                </MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="dob">DOB</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="Pick date" />,
                  }}
                  slotProps={{
                    textField: {
                      id: "dob",
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
